<template>
  <div>
    <commonTable
      ref="commonTable"
      url="admin/devices/activate_list"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
      @isLoading="(val) => listLoading = val"
    >
      <template slot="search" slot-scope="scope">
        <el-button
          type="success"
          plain
          icon="el-icon-download"
          @click="exportData({
            url: '/admin/devices/activate_list',
            name: '用户设备列表',
            column,
            limit: 'per_page',
            method: 'GET',},
            {
              totalRecords: scope.totalRecords,
              searchValue: {
                ...scope.searchValue,
              },
            })"
          class="mb1"
          :loading="listLoading">导出</el-button>
      </template>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'
import { exportData } from "@/assets/js/exportData"
export default {
  name: 'coinManager',
  components: {
    commonTable
  },
  data () {
    return {
      gameChannelPackageList: [],
      exportData,
      listLoading: false,
    }
  },
  computed: {
    column () {
      return [
        {
          label: "设备初次激活时间",
          prop: "first_time",
          width: "160",
        },
        {
          label: "渠道包初次激活时间",
          prop: "created_date",
          width: "160",
        },
        {
          label: "渠道包ID",
          prop: "game_channel_package_id",
        },
        {
          label: "渠道包名",
          prop: "channel_package.name",
        },
        {
          label: "设备ID",
          prop: "gdid"
        },
        {
          label: "idfa",
          prop: "idfa",
        },
        {
          label: "oaid",
          prop: "oaid",
        },
        {
          label: "imei",
          prop: "imei",
        },
        {
          label: "手机型号",
          prop: "model",
        },
        {
          label: "已注册用户",
          prop: "user_ids",
        },
      ]
    },
    searchColumn () {
      return [
        {
          label: '日期（起）+ 日期（止）',
          prop: 'created_from+created_to',
          type: "date",
          // setDefault: true,
        },
        {
          label: "渠道包ID",
          prop: "game_channel_package_id",
          type: "select",
          option: this.gameChannelPackageList
        },
        {
          label: "设备ID",
          prop: "gdid",
          type: "input",
        },
        {
          label: "idfa",
          prop: "idfa",
          type: "input",
        },
        {
          label: "oaid",
          prop: "oaid",
          type: "input",
        },
        {
          label: "imei",
          prop: "imei",
          type: "input",
        },
        {
          label: "手机型号",
          prop: "model",
          type: "input",
        },
        {
          label: "用户ID",
          prop: "user_id",
          type: "input",
        },
      ]
    }
  },
  mounted () {
    this.getGameChannelPackageList()
  },
  methods: {
    getGameChannelPackageList () {
      fetch({
        url: "/admin/game_channel_packages/list",
        method: "GET",
        params: {
          per_page: 10000
        },
      }).then((res) => {
        if (res.data.status && res.data.data) this.gameChannelPackageList = res.data.data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.order-statistics {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 0;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-left: 10px;
  list-style: none;
  li {
    margin-right: 30px;
  }
}

</style>
